import React, { Fragment } from "react";
import styles from "./chat-user-msg.module.less";
import { UserMsgProps } from "../../types/chat-msg-types";
import ChatTime from "../chat-time";

const ChatUserMsg: React.FC<UserMsgProps> = (props: UserMsgProps) => {
    return (
        <div className={styles.ChatUserMsgLess}>
            <div className="chat-user-msg">
                {props.userMsg}
            </div>
            <ChatTime date={props.date}></ChatTime>
        </div>
    )
}

export default ChatUserMsg;